/**
 * Inventory items: things the player owns but has not used yet. Bought in
 * the Meteor Shop, carried until they are used on a target of the player's
 * choosing, and consumed at that point.
 *
 * Today the only items are the two grades of Gene Splice, which evolve a
 * dinosaur (see data/dinos.ts). The shape is deliberately open so later
 * systems can grant items that are not purchases at all.
 */

import type { SpliceGrade } from './dinos';

export interface ItemDef {
  id: string;
  name: string;
  description: string;
  /**
   * The splice's grade: it evolves any dinosaur whose own splice is this
   * grade or weaker (DinoDef.splice). The grade is the only thing the item
   * decides; the rest of eligibility is about the dinosaur.
   */
  grade: SpliceGrade;
}

export const ITEMS: readonly ItemDef[] = [
  {
    id: 'splice:gene',
    name: 'Gene Splice',
    description: 'Evolves one of the first eight dinosaurs.',
    grade: 'gene',
  },
  {
    id: 'splice:prime',
    name: 'Prime Splice',
    description: 'Evolves any dinosaur, however large.',
    grade: 'prime',
  },
];

export const ITEMS_BY_ID: ReadonlyMap<string, ItemDef> = new Map(ITEMS.map((i) => [i.id, i]));
